import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';

import { SpSwitchComponent } from '@ui/sp-switch';
import { SpRadioGroupComponent } from '@ui/sp-radio-group';
import { SpControlHandleComponent } from '@ui/sp-control-handle';

import { SpColorPickerModule } from '@components/sp-color-picker/src/sp-color-picker.module';
import { SpFormControlsModule } from '@components/sp-form-controls';
import { SpAnimationSettingsComponent } from '@components/sp-animation-settings';
import { SpButtonAdditionalEffectsSettingsComponent } from '@components/sp-button-additional-effects-settings';

import { WebSettingsModule } from '@web/shared/components/web-settings/web-settings.module';
import { WebEditorModule } from '@web/shared/components/web-editor/web-editor.module';
import { WebCustomIdComponent } from '@web/shared/components/web-custom-id/web-custom-id.component';

import { WebSynchronizeStyleToggleComponent } from '@web/shared/components/web-synchronize-style-toggle';
import { SpSliderComponent } from '@ui/sp-slider/src/sp-slider.component';
import { WebDeviceToggleComponent } from '@web/shared/components/web-device-toggle/web-device-toggle.component';

const MODULES = [
    CommonModule,
    ReactiveFormsModule,
    FormsModule,
    TranslateModule,
    SpSwitchComponent,
    SpRadioGroupComponent,
    SpControlHandleComponent,
    SpColorPickerModule,
    SpFormControlsModule,
    WebSettingsModule,
    SpAnimationSettingsComponent,
    SpButtonAdditionalEffectsSettingsComponent,
    WebEditorModule,
    WebDeviceToggleComponent,
    WebCustomIdComponent,
    WebSynchronizeStyleToggleComponent,
    SpSliderComponent,
];

@NgModule({
    imports: [...MODULES],
    exports: [...MODULES],
})
export class CommonElementsModule {}
